import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

export interface User {
  name: string;
  username: string;
  gender: string;
  dob: string;
  socials: {
    instagram: string;
    linkedin: string;
    x: string;
  };
  description: string;
  banner: string;
  profile_picture: string;
}

export const userApi: any = createApi({
  reducerPath: "userApi",
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getUserByIdData: builder.query<any, void>({
      query: (newData: any) => ({
        url: `/user/${newData?.userId}`,
        method: "GET",
      }),
    }),
    checkUsernameExists: builder.query<boolean, { username: string }>({
      query: ({ username }) => ({
        url: `/user/validate/username`,
        method: "GET",
        params: { username },
      }),
    }),
    userAction: builder.mutation<any, { user_id: string; action: string }>({
      query: ({ user_id, action }) => ({
        url: `/user/action/${action}`,
        method: "POST",
        data: { follows_user_id: user_id },
      }),
    }),
    userUpdate: builder.mutation<any, Partial<User>>({
      query: (payload) => ({
        url: `/user`,
        method: "PATCH",
        data: payload,
      }),
    }),
    suggestedUser: builder.query<any, { user_id: string; limit: number }>({
      query: ({ user_id, limit }) => ({
        url: `/user/${user_id}/suggested?limit=${limit || 3}`,
        method: "GET",
      }),
    }),
    getUserActivity: builder.query<
      any,
      { user_id: string; limit: number; offset: number; type: string }
    >({
      query: ({ user_id, limit, offset, type }) => ({
        url: `/user/${user_id}/activity?feed_limit=${limit}&feed_offset=${offset}${type ? `&type=${type}` : ""}`,
        method: "GET",
      }),
    }),
    getUserBookmark: builder.query<
      any,
      { limit: number; offset: number; topics: string }
    >({
      query: ({ limit, offset, topics }) => ({
        url: `/user/bookmarks?feed_limit=${limit}&feed_offset=${offset}&topics=${topics}`,
        method: "GET",
      }),
    }),
    getUserBadges: builder.query<any, { userId: string }>({
      query: ({ userId }) => ({
        url: `/user/${userId}/badges`,
        method: "GET",
      }),
    }),
    reportUser: builder.mutation({
      query: ({ data }) => ({
        url: `/user/report`,
        method: "POST",
        data: data,
      }),
    }),
  }),
});

export const {
  useLazyGetUserByIdDataQuery,
  useCheckUsernameExistsQuery,
  useUserActionMutation,
  useUserUpdateMutation,
  useSuggestedUserQuery,
  useLazyGetUserActivityQuery,
  useGetUserActivityQuery,
  useLazyGetUserBookmarkQuery,
  useLazyGetUserBadgesQuery,
  useReportUserMutation,
} = userApi;
